import _extends from "@babel/runtime/helpers/extends";
import { useReducer, createContext } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export var initialState = {};
export var Context = /*#__PURE__*/createContext({});
export var reducer = (state, action) => {
  return _extends({}, state, action);
};
export var Provider = _ref => {
  var {
    children,
    value
  } = _ref;
  var [state, dispatch] = useReducer(reducer, _extends({}, initialState, value));
  return /*#__PURE__*/_jsx(Context.Provider, {
    value: _extends({}, state, {
      dispatch
    }),
    children: children
  });
};